<span
  appTag
  size="small"
  [color]="color()"
>
  {{ labelKey() | translate }}
</span>
